export { default } from './password-checker'
